import { useEffect } from 'react';
import { Line } from "react-chartjs-2";
import { chartOptions } from '../../constants/plottingConstants';
import { useDynamicChartColors } from "../../hooks"
import { crosshairGuidesPlugin } from "../../utils/chart"
import ChartContainer from './ChartContainer';

const CustomMultiLineChart = ({ chartData, chartRef }) => {

    const colors = useDynamicChartColors(chartData.length)

    useEffect(() => {
        if (chartRef.current) {
            chartRef.current.resetZoom();
        }
    }, [chartData, chartRef]);

    return (
        <ChartContainer>
            <Line
                ref={chartRef}
                style={{ height: 'auto', width: 'auto' }}
                data={{
                    ...chartData,
                    datasets: chartData.map((dataset, idx) => ({
                        ...dataset,
                        borderColor: colors[idx],
                        pointBackgroundColor: colors[idx],
                    }))
                }}
                options={chartOptions}
                plugins={[crosshairGuidesPlugin]}
            />
        </ChartContainer>
    );
};

export default CustomMultiLineChart;